import { render, staticRenderFns } from "./brainCardiovascularDetailOld.vue?vue&type=template&id=6430a593"
import script from "./brainCardiovascularDetailOld.vue?vue&type=script&lang=js"
export * from "./brainCardiovascularDetailOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6430a593')) {
      api.createRecord('6430a593', component.options)
    } else {
      api.reload('6430a593', component.options)
    }
    module.hot.accept("./brainCardiovascularDetailOld.vue?vue&type=template&id=6430a593", function () {
      api.rerender('6430a593', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/bcs/brainCardiovascularDetailOld.vue"
export default component.exports